import { Select } from "antd";
import { useField } from "formik";

const SelectInput = (props) => {
    const { options, placeholder, name, size = "default size", onChangeValue = () => { },disabled=false } = props
    const [field, meta, helpers] = useField(name);

    return (
        <div className="form-group" style={{ width: "100%" }}>
            <Select
                name={name}
                value={field.value}
                placeholder={placeholder}
                optionFilterProp="label"
                size={size}
                style={{ width: "100%" }}
                showSearch
                onChange={(value) => {
                    console.log(value)
                    helpers.setValue(value);
                    onChangeValue(value)
                }}
                onBlur={() => helpers.setTouched(true)}
                options={options}
                status={meta.touched && meta.error && "error"}
                disabled={disabled}
            />
            {/* {meta.touched && meta.error ? (
                <span className="error-input-message">{meta.error}</span>
            ) : null} */}
        </div>
    );
}

export default SelectInput;